export default function Gallery() {
  return (
    <section id="gallery" className="py-16 sm:py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <span className="text-[#9bc53d] text-sm font-semibold tracking-wider uppercase">Galeria</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2d5016] mt-4 mb-4 sm:mb-6">
            Nossos Destaques
          </h2>
          <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto px-4">
            Confira a qualidade e variedade dos nossos produtos
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          <div className="relative overflow-hidden rounded-2xl shadow-lg group h-64 sm:h-72 md:h-80">
            <img
              src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/3863319b31afa3309dadf27edd8a9e9a.png"
              alt="Produtos Frescos"
              className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4 sm:p-6">
              <p className="text-white font-semibold text-base sm:text-lg">Produtos Frescos</p>
            </div>
          </div>

          <div className="relative overflow-hidden rounded-2xl shadow-lg group h-64 sm:h-72 md:h-80">
            <img
              src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/000593ba3542099bcaf47b2732fdee8c.png"
              alt="Verduras Selecionadas"
              className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4 sm:p-6">
              <p className="text-white font-semibold text-base sm:text-lg">Verduras Selecionadas</p>
            </div>
          </div>

          <div className="relative overflow-hidden rounded-2xl shadow-lg group h-64 sm:h-72 md:h-80">
            <img
              src="https://readdy.ai/api/search-image?query=Premium%20quality%20raw%20beef%20steaks%20and%20noble%20meat%20cuts%20for%20barbecue%20displayed%20on%20elegant%20marble%20surface%20with%20minimal%20styling%2C%20emphasizing%20marbling%20texture%20and%20freshness%20of%20high-end%20butcher%20shop%20products&width=600&height=800&seq=gallery-meat-003&orientation=portrait"
              alt="Qualidade Premium"
              className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4 sm:p-6">
              <p className="text-white font-semibold text-base sm:text-lg">Qualidade Premium</p>
            </div>
          </div>

          <div className="relative overflow-hidden rounded-2xl shadow-lg group h-64 sm:h-72 md:h-80">
            <img
              src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/b46f8bbf399933abe5cecabd66a55da1.png"
              alt="Frutas da Estação"
              className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4 sm:p-6">
              <p className="text-white font-semibold text-base sm:text-lg">Frutas da Estação</p>
            </div>
          </div>

          <div className="relative overflow-hidden rounded-2xl shadow-lg group h-64 sm:h-72 md:h-80">
            <img
              src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/b08c6d67cf554a97b8efcea4334154af.png"
              alt="Legumes Frescos"
              className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4 sm:p-6">
              <p className="text-white font-semibold text-base sm:text-lg">Legumes Frescos</p>
            </div>
          </div>

          <div className="relative overflow-hidden rounded-2xl shadow-lg group h-64 sm:h-72 md:h-80">
            <img
              src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/425064cc495852770fc85d417c44b1ec.png"
              alt="Ambiente Acolhedor"
              className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4 sm:p-6">
              <p className="text-white font-semibold text-base sm:text-lg">Ambiente Acolhedor</p>
            </div>
          </div>
        </div>

        <div className="text-center mt-8 sm:mt-12">
          <a
            href="https://www.instagram.com/ranchodaverdura/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#2d5016] font-semibold hover:text-[#9bc53d] transition-colors whitespace-nowrap text-sm sm:text-base"
          >
            <i className="ri-instagram-line text-lg sm:text-xl"></i>
            Ver mais no Instagram
          </a>
        </div>
      </div>
    </section>
  );
}